import React, { useEffect, useState } from 'react';

import { bemCssModules, getTestId } from '@utils';

import { useStore, walletActions } from '@modules';
import { CryptoCurrencyEnum } from '@modules/global/types';

import AddressBlock from '@components/AddressBlock';

import OperationsDisabledDisclaimer from '../../OperationsDisabledDisclaimer';
import { useCustomContext } from '../../context';

import style from './Deposit.scss';

const cn = bemCssModules(style, 'Deposit');
const ti = getTestId('Deposit');

const Deposit: CustomFC = ({ className }) => {
  const [{ global }, dispatch] = useStore();
  const [address, setAddress] = useState('');
  const { left } = useCustomContext();
  const { crypto } = global.currencies;

  const fromCurrency = left?.value as CryptoCurrencyEnum;

  useEffect(() => {
    if (CONST.operationsDisabled) return;
    if (fromCurrency && crypto.includes(fromCurrency)) {
      dispatch(walletActions.getTopupAddress(fromCurrency))
        .unwrap()
        .then(res => {
          setAddress(res.data.address);
        });
    }
  }, [crypto, fromCurrency]);

  return (
    <div className={cn(null, [className])} data-testid={ti()}>
      {CONST.operationsDisabled ? (
        <OperationsDisabledDisclaimer />
      ) : (
        <AddressBlock address={address} />
      )}
    </div>
  );
};

export default Deposit;
